// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--ykkVt","seperator":"seperator--R1B1o"};